"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// Customer Loyalty Report API
var qs_1 = __importDefault(require("qs"));
var api_base_1 = __importDefault(require("./api_base"));
var NpsModes;
(function (NpsModes) {
    NpsModes["CHILDREN"] = "children";
    NpsModes["FRANCHISES"] = "franchises";
})(NpsModes = exports.NpsModes || (exports.NpsModes = {}));
exports.default = {
    get: function (organizationId, params) {
        var query = qs_1.default.stringify(params);
        return Promise.all([
            api_base_1.default.get("mock/organizations/" + organizationId + "/nps?" + query),
            api_base_1.default.get("organizations/" + organizationId + "/vocabulary")
        ]).then(function (_a) {
            var report = _a[0], vocabulary = _a[1];
            return {
                facets: report.data.data.facets,
                rows: report.data.data.rows,
                total_pages: report.data.total_pages,
                total_records: report.data.total_records,
                vocabulary: vocabulary.data.data
            };
        });
    }
};
//# sourceMappingURL=nps_api.js.map